'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Fab = require('./Fab');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Fab).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Fab/index.js
// module id = 275
// module chunks = 0